import React from "react";
import { useField, useFormikContext } from "formik";

// material
import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  MenuItem,
  RadioGroup,
  Radio,
  Typography,
  TextField,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";

// ----------------------------------------------------------------------

const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

export default function UploadFormPage2C(props) {
  const formikProps = useFormikContext();

  const {
    formField: {
      yourResearchField,
      presentProgressResearchProject2c,
      articleTitle,
      manuscriptId2c,
      typeManuscript,
      journal,
      subjectAreaCategory,
      journalRanking2c,
      authors,
      uploadResearchPublication,
      receivedDate,
      revisedDate,
      acceptedDate,
      publishedDate
    }
  } = props;

  const [yourResearchFieldField, yourResearchFieldMeta] =
    useField(yourResearchField);
  const [
    presentProgressResearchProject2cField,
    presentProgressResearchProject2cMeta
  ] = useField(presentProgressResearchProject2c);
  const [articleTitleField, articleTitleMeta] = useField(articleTitle);
  const [manuscriptId2cField, manuscriptId2cMeta] = useField(manuscriptId2c);
  const [typeManuscriptField, typeManuscriptMeta] = useField(typeManuscript);
  const [journalField, journalMeta] = useField(journal);
  const [subjectAreaCategoryField, subjectAreaCategoryMeta] =
    useField(subjectAreaCategory);
  const [journalRanking2cField, journalRanking2cMeta] =
    useField(journalRanking2c);
  const [authorsField, authorsMeta] = useField(authors);
  const [uploadResearchPublicationField, uploadResearchPublicationMeta] =
    useField(uploadResearchPublication);
  const [receivedDateField, receivedDateMeta] = useField(receivedDate);
  const [revisedDateField, revisedDateMeta] = useField(revisedDate);
  const [acceptedDateField, acceptedDateMeta] = useField(acceptedDate);
  const [publishedDateField, publishedDateMeta] = useField(publishedDate);

  return (
    <Page title="2C: Final Report (last year of PhD program)">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">
            PART: Grade/Progress/Final Report (Continue)
          </Typography>
        </Box>
        <Box sx={{ pb: 5 }}>
          <Typography variant="h5">
            2C: Final Report (last year of PhD program)
          </Typography>
        </Box>
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {yourResearchField.label}
            </Typography>
            <TextField
              select
              variant="outlined"
              name={yourResearchFieldField.name}
              value={yourResearchFieldField.value}
              onChange={(e) => yourResearchFieldField.onChange(e)}
              error={Boolean(
                yourResearchFieldMeta.touched && yourResearchFieldMeta.error
              )}
              helperText={
                yourResearchFieldMeta.touched && yourResearchFieldMeta.error
              }
            >
              <MenuItem value={"science_field"}>Science field</MenuItem>
              <MenuItem value={"humanities_and_social_science"}>
                Humanities and Social Science
              </MenuItem>
            </TextField>
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {presentProgressResearchProject2c.label}
            </Typography>
            <RadioGroup
              name={presentProgressResearchProject2cField.name}
              value={presentProgressResearchProject2cField.value}
              onChange={(e) =>
                presentProgressResearchProject2cField.onChange(e)
              }
            >
              <FormControlLabel
                value="section A"
                control={<Radio />}
                label="Section A: Selecting journal / Writing publication for submission"
              />
              <FormControlLabel
                value="section B"
                control={<Radio />}
                label="Section B: Submission / Under review process"
              />
              <FormControlLabel
                value="section C"
                control={<Radio />}
                label="Section C: Being accepted for publication / Published available"
              />
            </RadioGroup>
            {presentProgressResearchProject2cMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {presentProgressResearchProject2cMeta.error}
              </span>
            )}
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{articleTitle.label}</Typography>
            <TextField
              multiline
              rows={4}
              name={articleTitleField.name}
              value={articleTitleField.value}
              onChange={(e) => articleTitleField.onChange(e)}
              error={Boolean(
                articleTitleMeta.touched && articleTitleMeta.error
              )}
              helperText={articleTitleMeta.touched && articleTitleMeta.error}
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {manuscriptId2c.label}
              </Typography>
              <TextField
                name={manuscriptId2cField.name}
                value={manuscriptId2cField.value}
                onChange={(e) => manuscriptId2cField.onChange(e)}
                error={Boolean(
                  manuscriptId2cMeta.touched && manuscriptId2cMeta.error
                )}
                helperText={
                  manuscriptId2cMeta.touched && manuscriptId2cMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {typeManuscript.label}
              </Typography>
              <TextField
                name={typeManuscriptField.name}
                value={typeManuscriptField.value}
                onChange={(e) => typeManuscriptField.onChange(e)}
                error={Boolean(
                  typeManuscriptMeta.touched && typeManuscriptMeta.error
                )}
                helperText={
                  typeManuscriptMeta.touched && typeManuscriptMeta.error
                }
              />
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{journal.label}</Typography>
            <TextField
              name={journalField.name}
              value={journalField.value}
              onChange={(e) => journalField.onChange(e)}
              error={Boolean(journalMeta.touched && journalMeta.error)}
              helperText={journalMeta.touched && journalMeta.error}
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {subjectAreaCategory.label}
              </Typography>
              <TextField
                name={subjectAreaCategoryField.name}
                value={subjectAreaCategoryField.value}
                onChange={(e) => subjectAreaCategoryField.onChange(e)}
                error={Boolean(
                  subjectAreaCategoryMeta.touched &&
                    subjectAreaCategoryMeta.error
                )}
                helperText={
                  subjectAreaCategoryMeta.touched &&
                  subjectAreaCategoryMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {journalRanking2c.label}
              </Typography>
              <TextField
                name={journalRanking2cField.name}
                value={journalRanking2cField.value}
                onChange={(e) => journalRanking2cField.onChange(e)}
                error={Boolean(
                  journalRanking2cMeta.touched && journalRanking2cMeta.error
                )}
                helperText={
                  journalRanking2cMeta.touched && journalRanking2cMeta.error
                }
              />
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{authors.label}</Typography>
            <TextField
              name={authorsField.name}
              value={authorsField.value}
              onChange={(e) => authorsField.onChange(e)}
              error={Boolean(authorsMeta.touched && authorsMeta.error)}
              helperText={authorsMeta.touched && authorsMeta.error}
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {uploadResearchPublication.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={uploadResearchPublicationField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `uploadResearchPublication.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                uploadResearchPublicationMeta.touched &&
                  uploadResearchPublicationMeta.error
              )}
              helperText={
                uploadResearchPublicationMeta.touched &&
                uploadResearchPublicationMeta.error
              }
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">{receivedDate.label}</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={receivedDateField.name}
                  value={receivedDateField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        receivedDateField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(receivedDateField.name, date);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        receivedDateMeta.touched && receivedDateMeta.error
                      )}
                      helperText={
                        receivedDateMeta.touched && receivedDateMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">{revisedDate.label}</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={revisedDateField.name}
                  value={revisedDateField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        revisedDateField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(revisedDateField.name, date);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        revisedDateMeta.touched && revisedDateMeta.error
                      )}
                      helperText={
                        revisedDateMeta.touched && revisedDateMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Stack>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">{acceptedDate.label}</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={acceptedDateField.name}
                  value={acceptedDateField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        acceptedDateField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(acceptedDateField.name, date);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        acceptedDateMeta.touched && acceptedDateMeta.error
                      )}
                      helperText={
                        acceptedDateMeta.touched && acceptedDateMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">{publishedDate.label}</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={publishedDateField.name}
                  value={publishedDateField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        publishedDateField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(publishedDateField.name, date);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        publishedDateMeta.touched && publishedDateMeta.error
                      )}
                      helperText={
                        publishedDateMeta.touched && publishedDateMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Stack>
        </Stack>
      </Container>
    </Page>
  );
}
